/**
 * Identifies failures that use the console's legacy `errorCode` envelope.
 *
 * New semantic command responses intentionally omit `errorCode`; a missing
 * field therefore means that this shared compatibility rule does not apply.
 */
export function isLegacyApiErrorResponse(data) {
  if (!data || !Object.prototype.hasOwnProperty.call(data, 'errorCode')) {
    return false;
  }

  // Preserve compatibility with legacy APIs that may serialize the code as a string.
  return data.errorCode != 0;
}

